function Loading() {
  return <p>...loading</p>
}

export default Loading